module.exports = __webpack_public_path__ + "img/portfolio-cover.d63ea486.png";